import { BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Outlet from "./Outlet";
import type OutreachTopic from "./OutreachTopic";

@Model()
class OutletsTopic extends ApplicationRecord {
  static jsonapiType = "outlets_topics";

  @BelongsTo() outlet: Outlet;

  @BelongsTo() outreachTopic: OutreachTopic;
}

export default OutletsTopic;
